module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "id": "toolbar"
    }
  }, [_c('section', {
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    attrs: {
      "id": "navigation-head"
    }
  }, [(_vm.showImportExport) ? _c('div', {
    staticClass: "import-export-buttons"
  }, [_c('input', {
    ref: "importLibrary",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.importDataAsFile($event, 'library')
      }
    }
  }), _vm._v(" "), _c('input', {
    ref: "importInput",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.importDataAsFile($event, 'floorplan')
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Open Floorplan"
    }
  }, [_c('open-floorplan-svg', {
    staticClass: "button",
    attrs: {
      "id": "import"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$refs.importInput.click()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Save Floorplan"
    }
  }, [_c('save-floorplan-svg', {
    staticClass: "button",
    attrs: {
      "id": "export"
    },
    nativeOn: {
      "click": function($event) {
        _vm.exportData($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Import Library"
    }
  }, [_c('import-library-svg', {
    staticClass: "button",
    nativeOn: {
      "click": function($event) {
        _vm.$refs.importLibrary.click()
      }
    }
  })], 1), _vm._v(" "), (_vm.enable3DPreview) ? _c('div', {
    attrs: {
      "title": "Open 3D Previewer"
    }
  }, [_c('globe-icon-svg', {
    staticClass: "button",
    nativeOn: {
      "click": function($event) {
        _vm.open3DPreviewer($event)
      }
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "undo-redo"
    }
  }, [_c('div', {
    attrs: {
      "title": "undo"
    }
  }, [_c('undo-svg', {
    staticClass: "button",
    class: {
      'disabled': !_vm.timetravelInitialized
    },
    nativeOn: {
      "click": function($event) {
        _vm.undo($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "title": "redo"
    }
  }, [_c('redo-svg', {
    staticClass: "button",
    class: {
      'disabled': !_vm.timetravelInitialized
    },
    attrs: {
      "disabled": !_vm.timetravelInitialized
    },
    nativeOn: {
      "click": function($event) {
        _vm.redo($event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "mode-tabs"
    }
  }, [_c('li', {
    staticClass: "tab",
    class: {
      active: _vm.modeTab === 'floorplan'
    },
    attrs: {
      "data-modetab": "floorplan"
    },
    on: {
      "click": function($event) {
        _vm.modeTab = 'floorplan'
      }
    }
  }, [_c('span', [_vm._v("\n          Floorplan\n          "), _c('tab-floorplan-svg', {
    staticClass: "icon"
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "tab",
    class: {
      active: _vm.modeTab === 'assign'
    },
    on: {
      "click": function($event) {
        _vm.modeTab = 'assign'
      }
    }
  }, [_c('span', [_vm._v("\n          Assignments\n          "), _c('tab-assign-svg', {
    staticClass: "icon"
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "tab",
    class: {
      active: _vm.modeTab === 'components'
    },
    attrs: {
      "data-modetab": "components"
    },
    on: {
      "click": function($event) {
        _vm.modeTab = 'components'
      }
    }
  }, [_c('span', [_vm._v("\n          Components\n          "), _c('tool-component-svg', {
    staticClass: "icon"
  })], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "grid-settings"
    }
  }, [_c('div', {
    staticClass: "input-checkbox"
  }, [_c('label', [_vm._v("Story Below")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.previousStoryVisible),
      expression: "previousStoryVisible"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.previousStoryVisible) ? _vm._i(_vm.previousStoryVisible, null) > -1 : (_vm.previousStoryVisible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.previousStoryVisible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.previousStoryVisible = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.previousStoryVisible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.previousStoryVisible = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.mapEnabled) ? _c('div', {
    staticClass: "input-checkbox"
  }, [_c('label', [_vm._v("map")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mapVisible),
      expression: "mapVisible"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.mapVisible) ? _vm._i(_vm.mapVisible, null) > -1 : (_vm.mapVisible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.mapVisible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.mapVisible = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.mapVisible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.mapVisible = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-checkbox"
  }, [_c('label', [_vm._v("grid")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gridVisible),
      expression: "gridVisible"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gridVisible) ? _vm._i(_vm.gridVisible, null) > -1 : (_vm.gridVisible)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.gridVisible,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gridVisible = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.gridVisible = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.gridVisible = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-number"
  }, [_c('label', [_vm._v("spacing")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.lazy",
      value: (_vm.spacing),
      expression: "spacing",
      modifiers: {
        "number": true,
        "lazy": true
      }
    }],
    domProps: {
      "value": (_vm.spacing)
    },
    on: {
      "change": function($event) {
        _vm.spacing = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.allowSettingUnits) ? _c('label', [_vm._v(_vm._s(_vm.rwUnits))]) : _vm._e()]), _vm._v(" "), (_vm.allowSettingUnits) ? _c('PrettySelect', {
    ref: "unitsSelect",
    attrs: {
      "options": ['ft', 'm'],
      "value": _vm.rwUnits
    },
    on: {
      "change": _vm.updateUnits
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "title": "settings"
    },
    on: {
      "click": function($event) {
        _vm.showGroundPropsModal = true
      }
    }
  }, [_c('SettingsGear', {
    staticClass: "button"
  })], 1)], 1)]), _vm._v(" "), _c('section', {
    class: _vm.modeTab,
    attrs: {
      "id": "bottom"
    }
  }, [(_vm.modeTab === 'floorplan') ? [_c('div', {
    attrs: {
      "id": "instructions"
    }
  }, [_vm._v("Draw a floorplan and import images")]), _vm._v(" "), _c('div', {
    staticClass: "tools-list tools",
    attrs: {
      "id": "drawing-tools"
    }
  }, [_c('div', {
    class: {
      active: _vm.tool === 'Rectangle'
    },
    attrs: {
      "data-tool": "Rectangle",
      "title": "Rectangle"
    },
    on: {
      "click": function($event) {
        _vm.tool = 'Rectangle'
      }
    }
  }, [_c('tool-draw-rectangle-svg', {
    staticClass: "button"
  })], 1), _vm._v(" "), _c('div', {
    class: {
      active: _vm.tool === 'Polygon'
    },
    attrs: {
      "data-tool": "Polygon",
      "title": "Polygon"
    },
    on: {
      "click": function($event) {
        _vm.tool = 'Polygon'
      }
    }
  }, [_c('tool-draw-polygon-svg', {
    staticClass: "button"
  })], 1), _vm._v(" "), _c('div', {
    class: {
      active: _vm.tool === 'Fill'
    },
    attrs: {
      "data-tool": "Fill",
      "title": "Fill"
    },
    on: {
      "click": function($event) {
        _vm.tool = 'Fill'
      }
    }
  }, [_c('tool-fill-svg', {
    staticClass: "button"
  })], 1), _vm._v(" "), _c('div', {
    class: {
      active: _vm.tool === 'Eraser'
    },
    attrs: {
      "data-tool": "Eraser",
      "title": "Eraser"
    },
    on: {
      "click": function($event) {
        _vm.tool = 'Eraser'
      }
    }
  }, [_c('tool-erase-svg', {
    staticClass: "button"
  })], 1), _vm._v(" "), _c('div', {
    class: {
      active: _vm.tool === 'Image'
    },
    attrs: {
      "data-tool": "Image",
      "title": "Image"
    },
    on: {
      "click": _vm.setImageTool
    }
  }, [_c('tool-image-svg', {
    staticClass: "button"
  })], 1)])] : _vm._e(), _vm._v(" "), (_vm.modeTab === 'components') ? [_c('div', {
    attrs: {
      "id": "instructions"
    }
  }, [(!_vm.currentComponentDefinition) ? _c('span', [_vm._v("Add fenestration, daylighting, and PV")]) : _c('span', [_vm._v("Click to place a " + _vm._s(_vm.currentComponentDefinition.name))])]), _vm._v(" "), _c('ComponentInstanceEditBar')] : _vm._e(), _vm._v(" "), (_vm.modeTab === 'assign') ? [_c('div', {
    attrs: {
      "id": "instructions"
    }
  }, [_vm._v("Assign thermal zones, etc, to spaces")])] : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "grid-tools"
    }
  }, [_c('RenderByDropdown'), _vm._v(" "), _c('div', {
    attrs: {
      "title": "zoom to fit"
    }
  }, [_c('ZoomToFitSvg', {
    staticClass: "button",
    nativeOn: {
      "click": function($event) {
        _vm.zoomToFit($event)
      }
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('section', {
    staticClass: "modals"
  }, [(_vm.showSaveModal) ? _c('SaveAsModal', {
    on: {
      "close": function () {
        _vm.showSaveModal = false;
      }
    }
  }) : (_vm.showGroundPropsModal) ? _c('Settings', {
    on: {
      "close": function($event) {
        _vm.showGroundPropsModal = false
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40563b8d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 746
// module chunks = 2